<script lang="ts">
	import type { Side, SearchField } from 'utility/search-fields'

	import Autocomplete from '@isoftdata/svelte-autocomplete'
	import EditModeControls from 'components/search/EditModeControls.svelte'
	import Pin from 'components/search/Pin.svelte'
	import type { ComponentProps } from 'svelte'
	import type { SvelteSet } from 'svelte/reactivity'

	interface SideOption {
		label: string
		value: Side
	}

	const sideList: SideOption[] = [
		{ label: 'Both', value: 'BOTH' },
		{ label: 'Left', value: 'LEFT' },
		{ label: 'N/A', value: 'NA' },
		{ label: 'Right', value: 'RIGHT' },
	]

	interface Props
		extends Omit<ComponentProps<typeof Autocomplete<SideOption | null>>, 'value' | 'options' | 'emptyValue'> {
		searchField: SearchField
		inEditMode: boolean
		pinnedSearchFields: SvelteSet<SearchField['key']> //Required
		selectedSearchFieldsKeys: SvelteSet<SearchField['key']> //Required
		initialValue?: Side
		side?: SideOption | null
		disabled?: boolean
	}

	let {
		searchField,
		inEditMode,
		pinnedSearchFields = $bindable(),
		selectedSearchFieldsKeys = $bindable(),
		initialValue = undefined,
		side = $bindable(null),
		disabled = false,
		...rest
	}: Props = $props()

	if (initialValue) {
		side = sideList.find(option => option.value === initialValue) ?? null
	}
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<Autocomplete
		{...rest}
		label="Side"
		options={sideList}
		emptyValue={null}
		getLabel={option => option?.label ?? 'Any'}
		disabled={disabled || inEditMode}
		bind:value={side}
	>
		{#snippet hint()}
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		{/snippet}
	</Autocomplete>
</EditModeControls>
